import { ArrowDownLeft, ArrowUpRight, Wallet } from "lucide-react";
import { inr } from "../lib/api";

const Card = ({ label, value, icon: Icon, grad, testid, delay }) => (
  <div className={`rounded-2xl bg-gradient-to-br ${grad} p-5 sm:p-6 shadow-lg rise`} style={{ animationDelay: delay }} data-testid={testid}>
    <div className="flex items-center justify-between text-white/90">
      <span className="text-sm sm:text-base font-medium">{label}</span>
      <Icon className="h-5 w-5" />
    </div>
    <p className="font-mono font-bold text-2xl sm:text-3xl mt-3 text-white" data-testid={`${testid}-value`}>{inr(value)}</p>
  </div>
);

export const SummaryCards = ({ data }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <Card label="Total Deposit" value={data.total_deposit} icon={ArrowDownLeft} grad="from-emerald-500 to-green-800" testid="total-deposit-card" delay="0ms" />
    <Card label="Total Withdraw" value={data.total_withdraw} icon={ArrowUpRight} grad="from-red-500 to-red-900" testid="total-withdraw-card" delay="60ms" />
    <Card label="Net (Deposit − Withdraw)" value={data.balance} icon={Wallet} grad={data.balance < 0 ? "from-amber-600 to-yellow-900" : "from-blue-500 to-blue-900"} testid="net-balance-card" delay="120ms" />
  </div>
);
